const colors = [
    "#F56A00", // orange
    "#7265E6", // purple
    "#FFBF00", // gold
    "#00A2AE", // cyan
    "#87D068", // green
    "#108EE9", // blue
    "#FF85C0", // pink
    "#722ED1", // violet
    "#13C2C2", // teal
    "#EB2F96", // magenta
];

export const getColorFromLetter = (letter: string): string => {
    const code = letter.toUpperCase().charCodeAt(0);
    return colors[code % colors.length];
};
